import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/opt/buildhome/repo/app/layouts/custom.vue").then(m => m.default || m))
}